<template>
  <div class="survey-op">
    <div class="survey-name">
      <span>{{ survey.name }}</span>
    </div>

    <div class="survey-options">
      <form>
        <input v-if="!users" type="text" name="newUser" />

        <select v-if="users" :id="survey.id_">
          <option value="none" disabled selected>{{
            translations[language][NONE]
          }}</option>
          <option
            v-for="user in orderedUsers"
            :key="user.username"
            :value="user.username"
          >
            {{ user.username }}
          </option>
        </select>

        <button @click.prevent="operateSurvey">
          <span v-if="loading"><Loader color="#fff"/></span>
          <span v-else> {{ parseTranslation(CONFIRM) }} </span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Loader from '@/components/loading/Loader-3'

import * as translationSurveyChange from './SurveyChange.translations'

const { default: translations, ...translationKeys } = translationSurveyChange

export default {
  name: 'surveyoperation',

  components: {
    Loader,
  },

  props: {
    users: Array,
    survey: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      loading: false,
    }
  },

  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall']),

    async operateSurvey(e) {
      if (this.loading) return

      this.loading = true

      const ownerDoc = document.getElementById(this.survey.id_)

      const result = await this.executeSurveyAPICall({
        path: '/survey/change-ownership',
        method: 'POST',
        payload: {
          newUser: ownerDoc.options[ownerDoc.selectedIndex].value,
          survey_id: this.survey.id_,
        },
      })

      if (!result) return (this.loading = false)

      document.getElementById(this.survey.id_).value = 'none'

      this.sendMessage(result.message)
      this.$emit('changed')

      this.loading = false
    },
  },
  computed: {
    // ordenar em ordem alfabética em um array em um v-for
    orderedUsers() {
      function compare(a, b) {
        if (a.username.toLowerCase() < b.username.toLowerCase()) return -1
        return 0
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.users.sort(compare)
    },
  },
}
</script>
<style lang="scss" scoped>
.survey-op {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0;
  &:last-child {
    margin-bottom: 0;
  }
}
.survey-name {
  flex: 1;
  display: flex;
  justify-content: center;
  span {
    @include tipography(16);
    text-transform: capitalize;
    text-align: center;
  }
  .light & {
    span {
      color: $gray-6;
    }
  }
}
.survey-options {
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  margin-left: 10px;
  form {
    display: flex;
    align-items: center;
    select {
      width: 130px;
      background: rgba(0, 0, 0, 0);
      @include tipography(14);
      padding: 2px 8px;
      outline: none;
      margin-right: 10px;
      border-radius: 15px;
      border: 1px solid $white;
      &:hover,
      &:focus {
        box-shadow: 0px 0px 6px $gray;
      }
      option {
        color: $main-two;
      }
    }
  }

  button {
    @include btn-style;
    width: 80px;
    height: 26px;
    display: inline-block;
    @include tipography(12);
    padding: 2px;
    margin: 0 0 0 15px;
    span {
      display: flex;
      justify-content: center;
    }
  }

  .light & {
    select {
      border: 1px solid $gray-5;
      color: $gray-6;
      option {
        color: $gray-6;
      }
    }
  }
}

@media (max-width: 767.98px) {
  .survey-options {
    form {
      justify-content: center;
      flex-direction: column;
      select {
        margin-right: 0;
      }
      button {
        margin: 10px 0 0 0;
      }
    }
  }
}
</style>
